import { motion } from 'framer-motion';
import styles from './NeonText.module.css';
import { cn } from '../../utils';

type NeonColor = 'pink' | 'cyan' | 'purple' | 'gradient';
type NeonEffect = 'glow' | 'flicker' | 'pulse' | 'none';

interface NeonTextProps {
  children: React.ReactNode;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'p';
  color?: NeonColor;
  effect?: NeonEffect;
  className?: string;
  animate?: boolean;
}

export function NeonText({
  children,
  as: Component = 'span',
  color = 'pink',
  effect = 'glow',
  className,
  animate = true,
}: NeonTextProps) {
  const colorClass = styles[`color${color.charAt(0).toUpperCase() + color.slice(1)}`];
  const effectClass = styles[`effect${effect.charAt(0).toUpperCase() + effect.slice(1)}`];

  if (animate) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <Component className={cn(styles.neonText, colorClass, effectClass, className)}>
          {children}
        </Component>
      </motion.div>
    );
  }

  return (
    <Component className={cn(styles.neonText, colorClass, effectClass, className)}>
      {children}
    </Component>
  );
}

interface GlitchTextProps {
  children: string;
  className?: string;
}

export function GlitchText({ children, className }: GlitchTextProps) {
  return (
    <span className={cn(styles.glitchText, className)} data-text={children}>
      {children}
    </span>
  );
}
